// @flow

import React from 'react';
import type { MarketingTemplate } from '../../../../types/marketingType';
import KeepeekMediaPatchwork from '../../../common/KeepeekMediaPatchwork';

type Props = {
  data: MarketingTemplate
}

function CarouselMedia({ data }: Props) {
  return (
    <div className="carousel-media">
      <div className="title">{data.title}</div>
      <KeepeekMediaPatchwork medias={data.medias} isAlreadyLoaded={false} />
    </div>
  );
}

export default CarouselMedia;
